module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "crtl",
    attrs: {
      "id": "d12e123"
    }
  }, [_vm._v("© 2008 by Denise Hunter")]), _vm._v(" "), _c('p', {
    staticClass: "crtl",
    attrs: {
      "id": "d12e125"
    }
  }, [_vm._v("All rights reserved. No portion of this book may be reproduced, stored in a retrieval system, or transmitted in any form or by any means—electronic, mechanical, photocopy, recording, scanning, or other—except for brief quotations in critical reviews or articles, without the prior written permission of the publisher.")]), _vm._v(" "), _c('p', {
    staticClass: "crtl",
    attrs: {
      "id": "d12e127"
    }
  }, [_vm._v("Published in Nashville, Tennessee, by Thomas Nelson. Thomas Nelson is a registered trademark of Thomas Nelson, Inc.")]), _vm._v(" "), _c('p', {
    staticClass: "crtl",
    attrs: {
      "id": "d12e129"
    }
  }, [_vm._v("Thomas Nelson, Inc., titles may be purchased in bulk for educational, business, fund-raising, or sales promotional use. For information, please e-mail SpecialMarkets@ThomasNelson.com.")]), _vm._v(" "), _c('p', {
    staticClass: "crtl",
    attrs: {
      "id": "d12e131"
    }
  }, [_vm._v("Scripture taken from the HOLY BIBLE: NEW INTERNATIONAL VERSION"), _c('sup', [_vm._v("®")]), _vm._v(". © 1973, 1978, 1984 by International Bible Society. Used by permission of Zondervan. All rights reserved.")]), _vm._v(" "), _c('p', {
    staticClass: "crtl",
    attrs: {
      "id": "d12e136"
    }
  }, [_vm._v("Publisher’s Note: This novel is a work of fiction. Names, characters, places, and incidents are either products of the author’s imagination or used fictitiously. All characters are fictional, and any similarity to people living or dead is purely coincidental.")]), _vm._v(" "), _c('p', {
    staticClass: "crt",
    attrs: {
      "id": "d12e138"
    }
  }, [_c('i', [_vm._v("Library of Congress Cataloging in Publication Data")])]), _vm._v(" "), _c('p', {
    staticClass: "crtl",
    attrs: {
      "id": "d12e141"
    }
  }, [_vm._v("Hunter, Denise, 1968–"), _c('br'), _vm._v(" Sweetwater gap / Denise Hunter.")]), _vm._v(" "), _c('p', {
    staticClass: "crtl",
    attrs: {
      "id": "d12e145"
    }
  }, [_vm._v("p. cm.")]), _vm._v(" "), _c('p', {
    staticClass: "crtl",
    attrs: {
      "id": "d12e147"
    }
  }, [_vm._v("ISBN 978-1-59554-259-5 (pbk.)"), _c('br'), _vm._v("I. Title."), _c('br'), _vm._v("PS3608.U5925S94 2008")]), _vm._v(" "), _c('p', {
    staticClass: "crtl",
    attrs: {
      "id": "d12e153"
    }
  }, [_vm._v("813'.6—dc22              2008045175")]), _vm._v(" "), _c('p', {
    staticClass: "crt",
    attrs: {
      "id": "d12e156"
    }
  }, [_c('i', [_vm._v("Printed in the United States of America")])]), _vm._v(" "), _c('p', {
    staticClass: "crt",
    attrs: {
      "id": "d12e159"
    }
  }, [_vm._v("08 09 10 11 12 RRD 5 4 3 2 1")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6b11a555","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Hunt_9781595542595_epub_c6_r1.vue
// module id = 69
// module chunks = 0